import { render } from "./SidePanelEstudiante.vue?vue&type=template&id=620c026a&scoped=true"
import script from "./SidePanelEstudiante.vue?vue&type=script&lang=js"
export * from "./SidePanelEstudiante.vue?vue&type=script&lang=js"

import "./SidePanelEstudiante.vue?vue&type=style&index=0&id=620c026a&scoped=true&lang=css"
import "../assets/bootstrap.min.css?vue&type=style&index=1&id=620c026a&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620c026a"]])

export default __exports__